import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue';
import VueResource from 'vue-resource';
import router from './router';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF, faTwitter, faInstagram, faTelegram, faFlickr, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.use(VueResource);

library.add(faFacebookF, faTwitter, faInstagram, faTelegram, faFlickr, faYoutube);
Vue.component('font-awesome-icon', FontAwesomeIcon);

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
